import { FragmentCache } from './cache.js';

export const cache = new FragmentCache();
